import { Action, RequestStatus, UseCaseStateGenerator } from '@lib/plugin-redux-core';
import { FormCategory, GET_FORM_CATEGORIES_USE_CASE } from '@module/form';
import {
  FormCategoriesGlobalState,
  GetFormCategiresWithAllOptionsUseCaseState,
} from './form-categories-global.states';

const handleGetFormCategiresWithAllOptionsUseCase: UseCaseStateGenerator<GetFormCategiresWithAllOptionsUseCaseState> =
  {
    name: GET_FORM_CATEGORIES_USE_CASE,
    executing: (state: FormCategoriesGlobalState): FormCategoriesGlobalState => {
      return {
        ...state,
        getFormCategiresWithAllOptionsStatus: RequestStatus.EXECUTE,
      };
    },
    success: (state: FormCategoriesGlobalState, action: Action): FormCategoriesGlobalState => {
      return {
        ...state,
        formCategiresWithAllOptions: action.payload as FormCategory[],
        getFormCategiresWithAllOptionsStatus: RequestStatus.SUCCESS,
      };
    },
    error: (state: FormCategoriesGlobalState, action: Action): FormCategoriesGlobalState => {
      return {
        ...state,
        error: action.error,
        getFormCategiresWithAllOptionsStatus: RequestStatus.ERROR,
      };
    },
    reset: (state: FormCategoriesGlobalState): FormCategoriesGlobalState => {
      return {
        ...state,
        getFormCategiresWithAllOptionsStatus: RequestStatus.RESET,
      };
    },
  };

export const formCategoriesGlobalHandlers = [handleGetFormCategiresWithAllOptionsUseCase];
